﻿import { Button, Pause } from '@core/ui';
import { useTranslation } from 'react-i18next';

interface Props {
    onClick: () => void;
}

export const WebinarButtonPause = ({ onClick }: Props) => {
    const { t } = useTranslation();

    return (
        <Button type="submit" variant="primary" onClick={onClick}>
            <Pause classNames="h-4 fill-current" />
            <span className="sr-only bc:not-sr-only bc:ml-3">{t('Broadcaster.Button.Pause')}</span>
        </Button>
    );
};
